/**
 * @author：
 * @update：
 * @description：
 **/
import { fileEcho,goodsClassList,properTypes,goodsTypeGroupingList,goodsTypeGroupingAdd,priceList,addPrice,addGoodsClassList,delGoodsClassList,goodsClassListUpload,editGoodsClassList,goodsSeeList } from '../../api/url'
import CusPagination from '@/components/cusPagination.vue';
import {transactionHttps} from "../../config/config";
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            fileEcho:fileEcho,
            className:'',//分类名称
            typeVal:'',//所属类型
            typeOption:[],
            commission:'',//佣金比例
            enableVal:'',//启禁用
            enableOption:[{value:'true',label:'启用'},{value:'false',label:'禁用'}],
            tableData: [],//表格数据
            isChange:false,//是否上下移动过

            //新增/编辑后台商品分类
            isEdit:false,//是否是编辑
            editId:'',//编辑的id
            addBackstageClass:false,
            addTypeName:'',//分类名称
            classification:[],//父级分类
            classificationValue:'',//父级分类选择的值
            typeData:[],//所属类型
            typeValue:'',//所属类型值
            enable:true,//启禁用状态
            isMore:false,//是否有属性分组
            groupingList:[],//属性分组
            priceList:[],//定价属性
            commissionRate:'',//佣金比例
            goodsNum:'',//关联商品数

            //商品属性分组
            goodsTypeGrouping:false,//商品属性分组弹窗
            goodsTypeGroupingEditBol:false,//商品属性分组是否编辑
            goodsTypeGroupingEditId:'',//商品属性分组编辑id
            goodsTypeGroupingName:'',//商品属性分组名称
            searchName:'',//搜索的属性名称
            searchList:[],//搜索数据
            searchActiveList:[],//选择的数据
            goodsTypeGroupingPage:1,//搜索数据分页
            goodsTypeGroupingSize:5,//搜索数据个数
            goodsTypeGroupingCount:0,//搜索数据总数

            //新增商品属性
            addGoodsAttributes:false,//新增商品属性弹窗
            goodsAttributesName:'',//新增商品属性名称
            goodsAttributesVal:[{name:''}],//新增商品属性内容
            goodsAttributesRadio:"RADIO",//选择形式
            textTypeValue:'STRING',//输入框类型
            minVal:'',//最小值
            maxVal:'',//最大值
            unit:'',//单位
            unlimited:false,//是否显示无限制

            //定价属性分组
            priceGrouping:false,//商品属性分组弹窗
            priceGroupingEditBol:false,//商品属性分组是否编辑
            priceGroupingGroupingEditId:'',//商品属性分组编辑id
            priceGroupingGroupingName:'',//商品属性分组名称
            priceGroupingSearchName:'',//搜索的属性名称
            priceGroupingSearchList:[],//搜索数据
            priceGroupingSearchActiveList:[],//选择的数据
            priceGroupingGroupingPage:1,//搜索数据分页
            priceGroupingGroupingSize:5,//搜索数据个数
            priceGroupingGroupingCount:0,//搜索数据总数

            //新增定价属性
            addPriceAttributes:false,//新增商品属性弹窗
            priceAttributesName:'',//新增商品属性名称
            priceAttributesVal:[{name:''}],//新增商品属性内容
            priceAttributesRadio:"RADIO",//选择形式
            priceTextTypeValue:'STRING',//输入框类型
            priceMinVal:'',//最小值
            priceMaxVal:'',//最大值
            priceUnit:'',//单位
            priceUnlimited:false,//是否显示无限制

            //关联商品查看
            classificationId:'',//分类id
            seeVisible:false,//列表查看
            goodsCountList:[],//商品列表总数据
            goodsList:[],//关联商品
            page2:1,//商品页数
            count2:0,//商品总条数
            size2:10,//商品每页条数
        };
    },
    // 自定义方法
    methods: {
        //新增后台商品分类
        addGoodsTypeBtn(){
            let data = {
                name:this.addTypeName,
                enabled:this.enable,
                properTypeId:this.typeValue,
                parentId:this.classificationValue[this.classificationValue.length-1],
            };
            if(this.addTypeName==''){
                this.$message({
                    showClose:true,
                    message:"请填写分类名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.classificationValue.length==2){
                if(this.groupingList.length==0){
                    this.$message({
                        showClose:true,
                        message:"请添加商品属性分组",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }
                if(this.priceList.length==0){
                    this.$message({
                        showClose:true,
                        message:"请添加定价属性",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }
                if(this.commissionRate==''){
                    this.$message({
                        showClose:true,
                        message:"请添加佣金比例",
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    return false
                }

                let arr = [];
                for(let i = 0; i < this.groupingList.length; i++){
                    let obj = {};
                    obj.name = this.groupingList[i].name;
                    if(this.groupingList[i].id){//编辑时带上id
                        obj.id =  this.groupingList[i].id;
                    }
                    let arr2 = [];
                    for(let j = 0; j < this.groupingList[i].data.length; j++){
                        let obj2 = {};
                        obj2.attributeTemplate ={id:this.groupingList[i].data[j].id};
                        obj2.searchable = this.groupingList[i].data[j].search;
                        obj2.optional = this.groupingList[i].data[j].select;
                        arr2.push(obj2)
                    }
                    obj.groupTemplates = arr2;
                    arr.push(obj)
                }
                data.attributeGroups = arr;//添加商品属性分组

                let arrs = [];
                for(let j = 0; j < this.priceList[0].data.length; j++){
                    let obj = {};
                    if(this.priceList[0].data[j].ids){//编辑时带上id
                        obj.id = this.priceList[0].data[j].ids;
                    }
                    obj.specificationTemplate ={id:this.priceList[0].data[j].id};
                    obj.searchable = this.priceList[0].data[j].search;
                    arrs.push(obj)
                }
                data.specificationTemplates = arrs;//添加定价属性分组
                data.rate = this.commissionRate;//佣金比例
            }
            if(this.isEdit==false){
                //新增
                this.$ajax.post(addGoodsClassList,data).then(res=>{
                    console.log(res);
                    this.addGoodsTypeClose();
                    this.dataList();
                },err=>{
                    console.log(err);
                })
            }else{
                //编辑
                data.id = this.editId;
                this.$ajax.put(editGoodsClassList(this.editId),data).then(res=>{
                    console.log(res);
                    this.addGoodsTypeClose();
                    this.dataList();
                },err=>{
                    console.log(err);
                })
            }

        },
        //编辑后台商品分类
        editOpen(item){
            console.log(item);
            this.isEdit=true;//是否是编辑
            this.editId=item.id;//编辑的id
            this.addGoodsTypeClose();
            this.addBackstageClass=true;
            this.types(1);//传参数阻止回显默认值

            this.addTypeName=item.name;//分类名称
            let str = item.identity.split('_');
            if(str.length==1){
                this.classificationValue =  '';//父级分类
            }else if(str.length==2){
                this.classificationValue =  [Number(str[0])];
            }else if(str.length==3){
                this.classificationValue = [Number(str[0]),Number(str[1])];
                this.isMore = true;
                //回显商品属性
                this.typeName = item.name;
                let arr = [];
                for(let i = 0; i < item.attributeGroups.length; i++){
                    let obj = {};
                    obj.name = item.attributeGroups[i].name;
                    obj.id = item.attributeGroups[i].id;
                    let arr2 = [];
                    for(let j = 0; j < item.attributeGroups[i].groupTemplates.length; j++){
                        let obj2 = {};
                        obj2.select = item.attributeGroups[i].groupTemplates[j].optional;
                        obj2.search = item.attributeGroups[i].groupTemplates[j].searchable;
                        obj2 = {...obj2,...item.attributeGroups[i].groupTemplates[j].attributeTemplate}
                        arr2.push(obj2)
                    }
                    obj.data = arr2;
                    arr.push(obj)
                }
                this.groupingList = arr;
                //回显定价属性
                let arrs = [{name:'',data:[]}];
                for(let i = 0; i < item.specificationTemplates.length; i++){
                    let obj = item.specificationTemplates[i].specificationTemplate;
                    obj.ids = item.specificationTemplates[i].id;
                    arrs[0].data.push(obj)
                }
                this.priceList = arrs;
                //佣金比例
                this.commissionRate = item.rate;
            }
            console.log(item.properTypeId)
            this.typeValue = item.properTypeId;//所属类型
            console.log(item.properTypeId)
            this.enable = item.enabled;//是否启用
        },
        //新增后台商品分类关闭
        addGoodsTypeClose(){
            this.classificationValue = '';
            this.addTypeName = '';
            this.enable = true;
            this.commissionRate = '';
            this.groupingList = [];
            this.priceList = [];
            this.isMore = false;
            this.addBackstageClass=false;
        },
        classificationChange(value){
            if(value.length==2){
                this.isMore = true
            }else{
                this.isMore = false
            }
        },
        //新增商品类型属性分组编辑
        addGoodsTypeListEdit(item){
            this.goodsTypeGroupingEditId = item.id;
            this.goodsTypeGroupingPage = 1;
            this.goodsTypeGrouping = true;
            this.goodsTypeGroupingEditBol = true;
            this.goodsTypeGroupingData();
            this.goodsTypeGroupingName = item.name;
            this.searchActiveList = [...item.data];
        },
        //新增商品类型属性分组删除
        addGoodsTypeListDel(index){
            this.$confirm('此操作将删除该分组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let arr = this.groupingList;
                arr.splice(index,1);
                this.groupingList = arr;
                // this.$message({
                //     type: 'success',
                //     message: '删除成功!'
                // });
            }).catch(() => {

            });
        },
        //新增定价属性分组编辑
        addPriceListEdit(item){
            this.priceGroupingGroupingEditId = item.id;
            this.priceGroupingGroupingPage = 1;
            this.priceGrouping = true;
            this.priceGroupingEditBol = true;
            this.priceGroupingData();
            this.priceGroupingName = item.name;
            this.priceGroupingSearchActiveList = [...item.data];
        },
        //新增定价属性分组删除
        addPriceListDel(index){
            this.$confirm('此操作将删除该分组, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let arr = this.priceList;
                arr.splice(index,1);
                this.priceList = arr;
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {

            });
        },

        /*新增/编辑商品属性分组*/
        //新增/编辑商品属性分组数据
        goodsTypeGroupingData(){
            let data = {
                name:this.searchName,
                enabled:true,
                pageNumber:this.goodsTypeGroupingPage,
                pageSize:this.goodsTypeGroupingSize
            }
            this.$ajax.get(goodsTypeGroupingList,data).then(res=>{
                console.log(res);
                for(let i = 0; i < res.data.rows.length; i++){
                    if(this.searchActiveList.length>0){
                        for(let j = 0; j < this.searchActiveList.length; j++){
                            if(res.data.rows[i].id==this.searchActiveList[j].id){
                                res.data.rows[i].bol = true;
                                break
                            }else{
                                res.data.rows[i].bol = false
                            }
                        }
                    }else{
                        res.data.rows[i].bol = false
                    }

                }
                this.searchList = res.data.rows;
                this.goodsTypeGroupingCount = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //新增/编辑商品属性分组数据选择
        addGoodsAttributesSelect(data,index){
            let arr = this.searchActiveList;
            arr.push(data);
            this.searchActiveList = arr;
            let arr2 = this.searchList;
            arr2[index].bol = true;
            this.searchList = arr2
        },
        //新增/编辑商品属性分组选择数据删除
        addGoodsAttributesDel(data,index){
            let arr = this.searchActiveList;
            arr.splice(index,1);
            let arr2 = this.searchList;
            for(let i = 0; i < arr2.length; i++){
                if(data.id==arr2[i].id){
                    arr2[i].bol = false;
                    break
                }
            }
            this.searchList = arr2
        },
        //新增/编辑商品属性分组选择数据清空
        empty(){
            this.searchActiveList = [];
            let arr2 = this.searchList;
            for(let i = 0; i < arr2.length; i++){
                arr2[i].bol = false;
            }
            this.searchList = arr2
        },
        //新增/编辑商品属性分组数据提交
        goodsTypeGroupingBtn(){
            if(this.goodsTypeGroupingName==''){
                this.$message({
                    showClose:true,
                    message:"请填写商品属性分组名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.searchActiveList.length==0){
                this.$message({
                    showClose:true,
                    message:"请选择分组属性",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            let dataList = this.searchActiveList;
            if(this.goodsTypeGroupingEditBol==false){
                //新增提交
                for(let i = 0; i < dataList.length; i++){
                    dataList[i].search = false;
                    dataList[i].select = true;
                }
                let arr = this.groupingList;
                arr.push({name:this.goodsTypeGroupingName,data:dataList});
                this.groupingList = [...arr];
            }else{
                //编辑提交
                for(let i = 0; i < dataList.length; i++){
                    if(dataList[i].search==undefined){
                        dataList[i].search = false;
                    }
                    if(dataList[i].select==undefined){
                        dataList[i].select = true;
                    }
                }
                let arr = [...this.groupingList];
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].id == this.goodsTypeGroupingEditId){
                        arr[i] = {name:this.goodsTypeGroupingName,data:dataList}
                    }
                }
                this.groupingList = [...arr];
            }
            this.groupingList = [...this.groupingList]
            this.goodsTypeGroupingClose();
        },
        //强制更新视图
        forceRefresh(){
            this.$forceUpdate()
        },
        //新增/编辑商品属性分组数据取消
        goodsTypeGroupingClose(){
            this.goodsTypeGroupingName = '';
            this.searchList = [];
            this.searchActiveList = [];
            this.goodsTypeGrouping = false;
        },

        /*新增商品属性*/
        //选择形式选择重置数据
        goodsAttributesRadioChange(){
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
        },
        //输入类型选择重置数据
        textTypeChange(){
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
        },
        //添加属性
        addAttributes(){
            let data = this.goodsAttributesVal;
            data.push({name:''});
            this.goodsAttributesVal = data;
        },
        //删除对应属性
        delGoodsAttributesVal(index){
            let data = this.goodsAttributesVal;
            if(data.length==1){
                return false
            }
            data.splice(index,1)
        },
        //新增商品属性保存
        addGoodsAttributesBtn() {
            if(this.goodsAttributesName==''){
                this.$message({
                    showClose:true,
                    message:"请填写属性名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name==''){
                        this.$message({
                            showClose:true,
                            message:"请填写输入类型",
                            type:'error',
                            center:true,
                            duration:3000
                        })
                        return false
                    }
                }
            }
            let data = {
                name:this.goodsAttributesName,
                type:this.goodsAttributesRadio
            };
            if(this.goodsAttributesRadio=='RADIO'||this.goodsAttributesRadio=='CHECKBOX'||this.goodsAttributesRadio=='SELECT'){
                let arr = [];
                for(let i = 0; i < this.goodsAttributesVal.length; i++){
                    if(this.goodsAttributesVal[i].name!=''){
                        arr.push(this.goodsAttributesVal[i].name)
                    }
                }
                data.value = arr.join(',');
            }
            data.valueType = this.textTypeValue;
            if(this.textTypeValue=='NUMBER'){
                data.min = this.minVal;
                data.max = this.maxVal;
                data.unit = this.unit;
                data.unlimited = this.unlimited;
            }
            this.$ajax.post(goodsTypeGroupingAdd,data).then(res=>{
                console.log(res);
                this.goodsTypeGroupingData();
                this.addGoodsAttributesClose();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //取消
        addGoodsAttributesClose(){
            this.goodsAttributesName='';
            this.goodsAttributesRadio = 'RADIO';//选择形式
            this.goodsAttributesVal = [{name:''}];
            this.textTypeValue='STRING';//输入框类型
            this.minVal='';//最小值
            this.maxVal='';//最大值
            this.unit='';//单位
            this.unlimited=false;//是否显示无限制
            this.addGoodsAttributes = false;//关闭窗口
        },

        /*定价属性分组*/
        //定价属性分组数据
        priceGroupingData(){
            let data = {
                name:this.priceGroupingSearchName,
                enabled:true,
                pageNumber:this.priceGroupingGroupingPage,
                pageSize:this.priceGroupingGroupingSize
            }
            this.$ajax.get(priceList,data).then(res=>{
                console.log(res);
                for(let i = 0; i < res.data.rows.length; i++){
                    if(this.priceGroupingSearchActiveList.length>0){
                        for(let j = 0; j < this.priceGroupingSearchActiveList.length; j++){
                            if(res.data.rows[i].id==this.priceGroupingSearchActiveList[j].id){
                                res.data.rows[i].bol = true;
                                break
                            }else{
                                res.data.rows[i].bol = false
                            }
                        }
                    }else{
                        res.data.rows[i].bol = false
                    }

                }
                this.priceGroupingSearchList = res.data.rows;
                this.priceGroupingGroupingCount = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //定价属性分组数据选择
        addPriceAttributesSelect(data,index){
            let arr = this.priceGroupingSearchActiveList;
            arr.push(data);
            this.priceGroupingSearchActiveList = arr;
            let arr2 = this.priceGroupingSearchList;
            arr2[index].bol = true;
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组选择数据删除
        addPriceAttributesDel(data,index){
            let arr = this.priceGroupingSearchActiveList;
            arr.splice(index,1);
            let arr2 = this.priceGroupingSearchList;
            for(let i = 0; i < arr2.length; i++){
                if(data.id==arr2[i].id){
                    arr2[i].bol = false;
                    break
                }
            }
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组选择数据清空
        priceEmpty(){
            this.priceGroupingSearchActiveList = [];
            let arr2 = this.priceGroupingSearchList;
            for(let i = 0; i < arr2.length; i++){
                arr2[i].bol = false;
            }
            this.priceGroupingSearchList = arr2
        },
        //定价属性分组数据提交
        priceGroupingBtn(){
            // if(this.priceGroupingGroupingName==''){
            //     this.$message({
            //         showClose:true,
            //         message:"请填写商品属性分组名称",
            //         type:'error',
            //         center:true,
            //         duration:3000
            //     })
            //     return false
            // }
            if(this.priceGroupingSearchActiveList.length==0){
                this.$message({
                    showClose:true,
                    message:"请选择分组属性",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            let dataList = this.priceGroupingSearchActiveList;
            if(this.priceGroupingEditBol==false){
                //新增提交
                for(let i = 0; i < dataList.length; i++){
                    dataList[i].search = false;
                    dataList[i].select = true;
                }
                let arr = this.priceList;
                arr.push({name:this.priceGroupingGroupingName,data:dataList});
                this.priceList = [...arr];
            }else{
                //编辑提交
                for(let i = 0; i < dataList.length; i++){
                    if(dataList[i].search==undefined){
                        dataList[i].search = false;
                    }
                    if(dataList[i].select==undefined){
                        dataList[i].select = true;
                    }
                }
                let arr = [...this.priceList];
                for(let i = 0; i < arr.length; i++){
                    if(arr[i].id == this.priceGroupingGroupingEditId){
                        arr[i] = {name:this.priceGroupingGroupingName,data:dataList}
                    }
                }
                this.priceList = [...arr];
            }
            this.priceList = [...this.priceList]
            this.priceGroupingClose();
        },
        //定价属性分组数据取消
        priceGroupingClose(){
            this.priceGroupingGroupingName = '';
            this.priceGroupingSearchList = [];
            this.priceGroupingSearchActiveList = [];
            this.priceGrouping = false;
        },

        /*新增定价属性*/
        //选择形式选择重置数据
        priceAttributesRadioChange(){
            this.priceAttributesVal = [{name:''}];
            this.priceTextTypeValue='STRING';//输入框类型
            this.priceMinVal='';//最小值
            this.priceMaxVal='';//最大值
            this.priceUnit='';//单位
            this.priceUnlimited=false;//是否显示无限制
        },
        //输入类型选择重置数据
        priceTextTypeChange(){
            this.priceMinVal='';//最小值
            this.priceMaxVal='';//最大值
            this.priceUnit='';//单位
            this.priceUnlimited=false;//是否显示无限制
        },
        //添加属性
        addPriceAttributesList(){
            let data = this.priceAttributesVal;
            data.push({name:''});
            this.priceAttributesVal = data;
        },
        //删除对应属性
        delPriceAttributesVal(index){
            let data = this.priceAttributesVal;
            if(data.length==1){
                return false
            }
            data.splice(index,1)
        },
        //新增定价属性保存
        addPriceAttributesBtn() {
            if(this.priceAttributesName==''){
                this.$message({
                    showClose:true,
                    message:"请填写属性名称",
                    type:'error',
                    center:true,
                    duration:3000
                })
                return false
            }
            if(this.priceAttributesRadio=='RADIO'||this.priceAttributesRadio=='CHECKBOX'||this.priceAttributesRadio=='SELECT'){
                for(let i = 0; i < this.priceAttributesVal.length; i++){
                    if(this.priceAttributesVal[i].name==''){
                        this.$message({
                            showClose:true,
                            message:"请填写输入类型",
                            type:'error',
                            center:true,
                            duration:3000
                        })
                        return false
                    }
                }
            }
            let data = {
                name:this.priceAttributesName,
                type:this.priceAttributesRadio
            };
            if(this.priceAttributesRadio=='RADIO'||this.priceAttributesRadio=='CHECKBOX'||this.priceAttributesRadio=='SELECT'){
                let arr = [];
                for(let i = 0; i < this.priceAttributesVal.length; i++){
                    if(this.priceAttributesVal[i].name!=''){
                        arr.push(this.priceAttributesVal[i].name)
                    }
                }
                data.value = arr.join(',');
            }
            if(this.priceAttributesRadio=='INPUT'){
                data.valueType = this.priceTextTypeValue;
            }
            if(this.priceTextTypeValue=='NUMBER'){
                data.min = this.priceMinVal;
                data.max = this.priceMaxVal;
                data.priceUnit = this.priceUnit;
                data.unlimited = this.priceUnlimited;
            }
            if(this.priceTextTypeValue=='DATE'){
                data.unlimited = this.priceUnlimited;
            }
            console.log(data)
            this.$ajax.post(addPrice,data).then(res=>{
                console.log(res);
                this.priceGroupingData();
                this.addPriceAttributesClose();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //取消
        addPriceAttributesClose(){
            this.priceAttributesName='';
            this.priceAttributesRadio = 'RADIO';//选择形式
            this.priceAttributesVal = [{name:''}];
            this.priceTextTypeValue='STRING';//输入框类型
            this.priceMinVal='';//最小值
            this.priceMaxVal='';//最大值
            this.priceUnit='';//单位
            this.priceUnlimited=false;//是否显示无限制
            this.addPriceAttributes = false;//关闭窗口
        },

        //删除提示
        delOpen(fun,id) {
            this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                fun(id);
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
        },
        //获取列表
        dataList(){
            this.$ajax.get(goodsClassList).then(res=>{
                console.log(res);
                for(let i = 0; i < res.data.length; i++){
                    res.data[i].rate = '';
                    if(res.data[i].children!=undefined&&res.data[i].children.length>0){
                        for(let j = 0; j < res.data[i].children.length; j++){
                            res.data[i].children[j].rate = ''
                        }
                    }
                }
                this.tableData = res.data;
                let arr = [];
                for(let i = 0; i < res.data.length; i++){
                    let obj = {};
                    obj.value =  res.data[i].id;
                    obj.label = res.data[i].name;
                    obj.disabled = !res.data[i].enabled;
                    if(res.data[i].children!=undefined&&res.data[i].children.length!=0){
                        let arr2 = [];
                        for(let j = 0; j < res.data[i].children.length; j++){
                            let obj2 = {};
                            obj2.value = res.data[i].children[j].id;
                            obj2.label = res.data[i].children[j].name;
                            if(obj.disabled){
                                obj2.disabled = true
                            }else{
                                obj2.disabled = !res.data[i].children[j].enabled;
                            }
                            arr2.push(obj2)
                        }
                        obj.children = arr2;
                    }
                    arr.push(obj)
                }
                this.classification = arr;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //删除
        delList(id){
            this.$ajax.delete(delGoodsClassList(id),{id:id}).then(res=>{
                console.log(res);
                this.$message({
                    showClose:true,
                    message:'删除成功',
                    type:'success',
                    center:true,
                    duration:3000
                })
                this.dataList();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //获取所属类型
        types(type){
            console.log(type)
            this.$ajax.get(properTypes).then(res=>{
                console.log(res);
                if(res.data.length>0){
                    this.typeData = res.data;
                    if(type==undefined){
                        this.typeValue = res.data[0].id;
                    }
                }
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })

        },
        //重置
        resetBtn(){
            this.className='';//分类名称
            this.typeVal='';//所属类型
            this.commission='';//佣金比例
            this.enableVal='';//启禁用
            this.dataList();
        },
        //保存
        goodsListBtn(){
            let data = this.tableData;
            this.$ajax.post(goodsClassListUpload,data).then(res=>{
                console.log(res);
                this.dataList();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
        //table选中操作
        tableSelect(selection, row) {
            this.loopChildren(row)
        },
        loopChildren(data) {
            console.log(data);
            if (!data.isChecked) {   //由行数据中的元素isChecked判断当前是否被选中
                this.$refs.tableRef.toggleRowSelection(data, true); //切换该子节点选中状态
                data.isChecked = true; //当前行isChecked标志元素切换为false
            } else {
                this.$refs.tableRef.toggleRowSelection(data, false);
                data.isChecked = false;
            }
            if (data.children) {
                data.children.map((item) => {
                    //只对有子节点的行响应
                    this.loopChildren(item)
                });
            }
        },
        //上移
        upItem(item) {
            let id = item.id;
            for(let i = 0; i < this.tableData.length; i++){
                if(id == this.tableData[i].id){
                    if(i==0){
                        return false
                    }
                    const upDate = this.tableData[i - 1];
                    this.tableData.splice(i - 1, 1);
                    this.tableData.splice(i, 0, upDate);
                    break;
                }else{
                    if(this.tableData[i].children){
                        for(let j = 0; j < this.tableData[i].children.length; j++){
                            if(id==this.tableData[i].children[j].id){
                                if(j==0){
                                    return false
                                }
                                const upDate = this.tableData[i].children[j - 1];
                                this.tableData[i].children.splice(j - 1, 1);
                                this.tableData[i].children.splice(j, 0, upDate);
                                break;
                            }else{
                                if(this.tableData[i].children[j].children){
                                    for(let k = 0; k < this.tableData[i].children[j].children.length; k++){
                                        if(id==this.tableData[i].children[j].children[k].id){
                                            if(k==0){
                                                return false
                                            }
                                            const upDate = this.tableData[i].children[j].children[k - 1];
                                            this.tableData[i].children[j].children.splice(k - 1, 1);
                                            this.tableData[i].children[j].children.splice(k, 0, upDate);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.isChange = true;
        },
        //下移
        downItem(item) {
            let id = item.id;
            for(let i = 0; i < this.tableData.length; i++){
                if(id == this.tableData[i].id){
                    if(i == this.tableData.length-1){
                        return false
                    }
                    const downDate = this.tableData[i + 1];
                    this.tableData.splice(i + 1, 1);
                    this.tableData.splice(i, 0, downDate);
                    break;
                }else{
                    if(this.tableData[i].children){
                        for(let j = 0; j < this.tableData[i].children.length; j++){
                            if(id==this.tableData[i].children[j].id){
                                if(j == this.tableData[i].children.length-1){
                                    return false
                                }
                                const downDate = this.tableData[i].children[j + 1];
                                this.tableData[i].children.splice(j + 1, 1);
                                this.tableData[i].children.splice(j, 0, downDate);
                                break;
                            }else{
                                if(this.tableData[i].children[j].children){
                                    for(let k = 0; k < this.tableData[i].children[j].children.length; k++){
                                        if(id==this.tableData[i].children[j].children[k].id){
                                            if(k == this.tableData[i].children[j].children.length-1){
                                                return false
                                            }
                                            const downDate = this.tableData[i].children[j].children[k + 1];
                                            this.tableData[i].children[j].children.splice(k + 1, 1);
                                            this.tableData[i].children[j].children.splice(k, 0, downDate);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.isChange = true;
        },
        //定价属性上下移
        upItem2(index,indexs){
            if(indexs==0){
                return false
            }
            let data = this.priceList[index].data;
            const upDate = this.priceList[index].data[indexs - 1];
            data.splice(indexs - 1, 1);
            data.splice(indexs, 0, upDate);
        },
        downItem2(index,indexs){
            console.log(indexs , this.priceList[index].data.length);
            if(indexs==this.priceList[index].data.length-1){
                return false
            }
            let data = this.priceList[index].data;
            const downDate = this.priceList[index].data[indexs + 1];
            data.splice(indexs + 1, 1);
            data.splice(indexs, 0, downDate);
        },

        //查看关闭
        seeClose(done){
            done();
            this.goodsList=[];//关联商品
            this.page2=1;//商品页数
        },
        //点击查看
        toSee(id){
            this.page2=1;
            this.classificationId = id;
            this.seeList();
            this.seeVisible = true;
        },
        //查看取消
        qxSee(){
            this.seeVisible = false;
            this.goodsList=[];//关联商品
            this.page2=1;//商品页数
        },
        //关联商品列表
        seeList(){
            let data = {
                classificationId:this.classificationId,
                pageNumber:this.page2,
                pageSize:this.size2
            }
            this.$ajax.get(goodsSeeList,data).then(res=>{
                console.log(res);
                this.goodsList = res.data.rows;
                this.count2 = res.data.total
            },err=>{
                console.log(err);
            })
        },
        jumpOpen(id){
            window.open(transactionHttps+'#/details?id='+id)
        }
    },
    // 数据观察监听
    watch: {
        goodsTypeGroupingPage(newData,oldData){
            this.goodsTypeGroupingData();
        },
        priceGroupingGroupingPage(newData,oldData){
            this.priceGroupingData();
        },
        page2(newData,oldData){
            this.seeList()
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        this.dataList();
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
